<template>
  <div class="face_teach">
    <h2 class="title_com">面授课程</h2>
    <section class="pd2430">
      <!-- 搜索 -->
      <MySearch
        :list1="selecteArr1"
        :triggerPhName="3"
        :triggerPhName2="1"
        :show2="0"
        :show3="0"
        @changeVal="changeVal"
        @resetPage="resetPage"
        @requestCommonFn="requestCommonFn"
      ></MySearch>
      <!-- 表格 -->
      <FaceCourseTB :list="faceCourseApiArr"> </FaceCourseTB>
      <!-- 分页 -->
      <Pagination
        :currentPage="currentPage"
        :pageSize="pageSize"
        :total="total"
        :selectSize="[10, 20, 30, 40]"
        @changePage="changePage"
        @changeSize="changeSize"
        v-if="faceCourseApiArr.length !== 0"
      ></Pagination>
    </section>
  </div>
</template>

<script>
import { FaceCourseApi } from "@/api/student";
export default {
  data() {
    return {
      // 状态1 未开始、2进行中 3 已结束 4 无限制
      selecteArr1: [
        {
          name: "全部",
          id: 5,
        },
        {
          name: "未开始",
          id: 1,
        },
        {
          name: "进行中",
          id: 2,
        },
        {
          name: "已结束",
          id: 3,
        },
        {
          name: "无限制",
          id: 4,
        },
      ],
      is_status: "", //状态
      title: "", // 面授课名
      faceCourseApiArr: [], // 面授课列表
      currentPage: 1, //当前页数
      pageSize: 10, // 当前页条数
      total: 11, // 总数
    };
  },
  methods: {
      // 重置页数
    resetPage() {
        this.currentPage = 1;
    },
    // 当前页数条数改变
    changeSize(size) {
      this.pageSize = size;
      this.requestCommonFn();
    },
    // 当前页数改变
    changePage(page) {
      this.currentPage = page;
      this.requestCommonFn();
    },
    // 修改查询的值
    changeVal(val) {
      this.title = val.workName;
      if (val.workPeople == 5) {
        this.is_status = "";
      } else {
        this.is_status = val.workPeople;
      }
    },
    // 面授课列表
    requestCommonFn() {
      FaceCourseApi({
        limit: this.pageSize,
        page: this.currentPage,
        user_id: this.userInfo.id,
        class_id: this.class_id,
        status: this.is_status,
        title: this.title,
      }).then((res) => {
        this.faceCourseApiArr = res.data.data;
        this.total = res.data.total;
      });
    },
    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      this.requestCommonFn();
    },
  },
  created() {
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.face_teach {
  background-color: #fff;
}
</style>